import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {PayMethodVoucher} from '@web/core/constants'
import {
    inputVoucherId,
    inputVoucherPinNo,
    updateVoucherBalance,
    updateVoucherLoginInfo,
    getInitialState,
} from '@web/slices/voucher/slice'

import type {VoucherReducers, MakeSliceOptions} from './interfaces'
import type {VoucherState} from '@web/slices/voucher/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<VoucherState, VoucherReducers, 'voucher', SliceSelectors<VoucherState>>({
        name: 'voucher',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(inputVoucherId, (state, {payload}) => {
                    if (payload.type === PayMethodVoucher.CULTURE_LAND) {
                        state.cultureLand.loginId = payload.id
                    } else if (payload.type === PayMethodVoucher.HAPPY_MONEY) {
                        state.happyMoney.loginId = payload.id
                    }
                })
                .addCase(inputVoucherPinNo, (state, {payload}) => {
                    if (payload.type === PayMethodVoucher.CULTURE_LAND) {
                        state.cultureLand.loginPassword = payload.pinNo
                    } else if (payload.type === PayMethodVoucher.HAPPY_MONEY) {
                        state.happyMoney.loginPassword = payload.pinNo
                    }
                })
                .addCase(updateVoucherBalance, (state, {payload}) => {
                    if (payload.type === PayMethodVoucher.CULTURE_LAND) {
                        state.cultureLand.balance = payload.balance
                    } else if (payload.type === PayMethodVoucher.HAPPY_MONEY) {
                        state.happyMoney.balance = payload.balance
                    }
                })
                .addCase(updateVoucherLoginInfo, (state, {payload}) => {
                    const {loginSuccessId, custId, certNo, sid, tid, balance} = payload.voucherInfo
                    const voucherType = payload.type === PayMethodVoucher.CULTURE_LAND ? 'cultureLand' : 'happyMoney'
                    state[voucherType] = {
                        ...state[voucherType],
                        loginSuccessId,
                        custId,
                        certNo,
                        sid,
                        tid,
                        balance,
                    }
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.voucher ?? state
            })
        },
    })
